import React, { useEffect, useMemo, useState } from "react";
import {
  Grid,
  Image,
  Icon,
  Header,
  Container,
  Label,
  Button,
  Segment,
  Loader,
  Card
} from "semantic-ui-react";
import "./mapstyles.css";
import YouTube from "react-youtube";
import { track } from "../analytics";
import ProductMap from "./HomeProduct/productMap";
import { shareOnMobile } from "react-mobile-share";

const FALLBACK_PRODUCT_IMAGE =
  "https://firebasestorage.googleapis.com/v0/b/foodchainapp-1531482755524.appspot.com/o/kaufland%2Fi6cli_1668090696103.jpg?alt=media&token=a4b41686-d932-4848-b6bf-a3d1266eed89";
const FALLBACK_PLACE_IMAGE =
  "https://firebasestorage.googleapis.com/v0/b/foodchainapp-1531482755524.appspot.com/o/kaufland%2Fkaufland-headquarter.jpg?alt=media&token=7b58af57-585b-461a-b2dc-5c6651fbfca1";
const KAUFLAND_LOGO =
  "https://firebasestorage.googleapis.com/v0/b/foodchainapp-1531482755524.appspot.com/o/kaufland%2Fkaufland-brei-logo-768x432.jpg?alt=media&token=047464a6-a890-4f23-a920-aa04c178e4e8";

const HARVEST_DATE_OVERRIDES = {
  products: {
    "6654b8a5c294260cc4268339": "Дата на бране: 27.09.24",
    "6654ba33a4b98a6e25742321": "Дата на бране: 28.09.24",
    "6654bd3aa4b98a4d52742323": "Дата на бране: 28.09.24"
  },
  inventories: {
    "65f7f66a652f61fe5d461bb9": "Дата на бране: 28.09.24"
  }
};

const createSvgIcon = (viewBox, path, accents = []) => color => (
  <svg
    className="map-details__nutrition-svg"
    role="img"
    aria-hidden="true"
    viewBox={viewBox}
  >
    <path fill={color} d={path} />
    {accents.map((accent, index) => (
      <path key={index} {...accent} />
    ))}
  </svg>
);

const NUTRITION_ICONS = {
  calories: color => (
    <Icon name="fire" className="map-details__nutrition-icon" style={{ color }} />
  ),
  carbs: createSvgIcon(
    "0 0 24 24",
    "M12 3c-4.142 0-7.5 2.239-7.5 5V11h1.2v7.5c0 1.38 1.12 2.5 2.5 2.5h7.6c1.38 0 2.5-1.12 2.5-2.5V11h1.2V8c0-2.761-3.358-5-7.5-5zm-2 11.5c0 .552-.448 1-1 1s-1-.448-1-1 .448-1 1-1 1 .448 1 1zm6 0c0 .552-.448 1-1 1s-1-.448-1-1 .448-1 1-1 1 .448 1 1z",
    [
      { fill: "#fff", fillOpacity: 0.32, d: "M8 12h1.5v2H8zm6.5 0H16v2h-1.5z" }
    ]
  ),
  fats: createSvgIcon(
    "0 0 24 24",
    "M12 3c-2.75 3.75-5.25 6.5-5.25 10.25 0 3.314 2.686 6 6 6s6-2.686 6-6C18.75 9.5 15.75 6.75 12 3zm0 14.5c-1.656 0-3-1.344-3-3 0-1.643 1.154-3.168 3-5.54 1.846 2.372 3 3.897 3 5.54 0 1.656-1.344 3-3 3z"
  ),
  proteins: createSvgIcon(
    "0 0 24 24",
    "M12 4C8.5 4 6 7.6 6 11.2 6 15 8.91 19 12 19s6-4 6-7.8C18 7.6 15.5 4 12 4zm0 11.6a3.2 3.2 0 1 1 0-6.4 3.2 3.2 0 0 1 0 6.4z",
    [{ fill: "#ffffff", fillOpacity: 0.35, d: "M12 10.2a1.8 1.8 0 1 0 0 3.6 1.8 1.8 0 0 0 0-3.6z" }]
  )
};

const NUTRITION_FACTS = [
  { key: "Калорий", label: "Калории", iconKey: "calories", color: "#f97316" },
  { key: "Въглехидрати", label: "Въглехидрати", iconKey: "carbs", color: "#facc15" },
  { key: "Мазнини", label: "Мазнини", iconKey: "fats", color: "#f59e0b" },
  { key: "Протеини", label: "Протеини", iconKey: "proteins", color: "#22c55e" }
];

const CERTIFICATION_LOGOS = [
  {
    url: "https://firebasestorage.googleapis.com/v0/b/foodchainapp-1531482755524.appspot.com/o/kaufland%2FGRASP.png?alt=media&token=0a5d58c6-cffb-466a-b0d2-51635d67939a",
    alt: "GRASP сертификат",
    title: "GLOBALG.A.P. GRASP",
    description:
      "Фокус върху социалната отговорност в земеделските стопанства и добрите практики при работа със служители."
  },
  {
    url: "https://firebasestorage.googleapis.com/v0/b/foodchainapp-1531482755524.appspot.com/o/kaufland%2FGlobal%20G.A.P..png?alt=media&token=8b0828db-0c39-4b98-8644-6040cf25c3bd",
    alt: "Global G.A.P. сертификат",
    title: "GLOBALG.A.P.",
    description:
      "Международен стандарт за безопасност на храните, проследимост и устойчиви земеделски практики."
  },
  {
    url: "https://firebasestorage.googleapis.com/v0/b/foodchainapp-1531482755524.appspot.com/o/kaufland%2Fnova-score-1.png?alt=media&token=4408915f-1316-49ae-b144-e7eb8f62eed4",
    alt: "NOVA хранителен профил",
    title: "NOVA 1",
    description:
      "Категория за минимално обработени храни – гаранция, че продуктът запазва естествените си качества."
  }
];

const BRAND_STORY_IMAGES = [
  {
    url: "https://firebasestorage.googleapis.com/v0/b/foodchainapp-1531482755524.appspot.com/o/kaufland%2Fobichat-me-i-nashite-i-chujdite-h8s-brey-d-1.webp?alt=media&token=a167aea0-a3ed-468b-8ea7-477224ee7c8b",
    alt: "Български вкусове"
  },
  {
    url: FALLBACK_PLACE_IMAGE,
    alt: "Kaufland България"
  }
];

const PROMO_SECTIONS = [
  {
    title: "Български зеленчуци",
    icon: "shopping basket",
    images: [
      {
        url: "https://firebasestorage.googleapis.com/v0/b/foodchainapp-1531482755524.appspot.com/o/kaufland%2Fc-2023-kw30-mob-products-zelenchutsi-7.webp?alt=media&token=9eb743fa-75f9-4f4f-acd7-520a9d83b22c",
        alt: "Български зеленчуци в Кауфланд"
      }
    ]
  },
  {
    title: "Проследяване на храната",
    icon: "linkify",
    images: [
      {
        url: "https://firebasestorage.googleapis.com/v0/b/foodchainapp-1531482755524.appspot.com/o/kaufland%2FTG-logo-3.png?alt=media&token=05f81b9f-5e02-463f-bb3b-a0139ac592ee",
        alt: "TraceGround"
      },
      {
        url: "https://firebasestorage.googleapis.com/v0/b/foodchainapp-1531482755524.appspot.com/o/kaufland%2FBrey-chetiri-stepenen-kontrol-kachestvo-d.webp?alt=media&token=f13b2c1b-260b-47c2-8a31-a91ff4028377",
        alt: "Четиристепенен контрол"
      }
    ]
  }
];

const SPINACH_RECIPES = [
  {
    title: "Огретен от спанак",
    description: "Продукти (4 порции)",
    url: "https://www.kaufland.bg/recepti/tursene-recepti/recepta-detail.%D0%BE%D0%B3%D1%80%D0%B5%D1%82%D0%B5%D0%BD-%D1%81%D0%BF%D0%B0%D0%BD%D0%B0%D0%BA.r_id=BG_247.html",
    image:
      "https://firebasestorage.googleapis.com/v0/b/foodchainapp-1531482755524.appspot.com/o/kaufland%2Frecipes%2Frecipe-bg-247_ogreten-ot-spanak.webp?alt=media&token=7dc1ec87-f7ca-42c0-87d1-64709b683374",
    time: "До 30 минути",
    level: "Начинаещи"
  },
  {
    title: "Спанак с тахан и чесън",
    description: "Продукти (3 порции)",
    url: "https://www.kaufland.bg/tursene/recepta-detail.r_id=BG_97.html",
    image:
      "https://firebasestorage.googleapis.com/v0/b/foodchainapp-1531482755524.appspot.com/o/kaufland%2Frecipes%2Frecipe-bg-97_spanak-s-tahan-i-chesun.webp?alt=media&token=91ef9faa-6563-45fb-9eb4-d0a14987bf63",
    time: "До 15 минути",
    level: "Начинаещи"
  }
];

const CARROT_RECIPES = [
  {
    title: "Морковена торта",
    description: "Продукти (12 парчета)",
    url: "https://www.kaufland.bg/recepti/tursene-recepti/recepta-detail.%D0%BC%D0%BE%D1%80%D0%BA%D0%BE%D0%B2%D0%B5%D0%BD%D0%B0-%D1%82%D0%BE%D1%80%D1%82%D0%B0.r_id=BG_675.html",
    image:
      "https://firebasestorage.googleapis.com/v0/b/foodchainapp-1531482755524.appspot.com/o/kaufland%2Frecipes%2Frecipe6243_moehrentorte-1.webp?alt=media&token=c83a2604-b79c-47a4-b489-7d891ab821c5",
    time: "Над 60 минути",
    level: "Напреднали"
  },
  {
    title: "Морковен тарт",
    description: "Продукти (8 парчета)",
    url: "https://www.kaufland.bg/recepti/tursene-recepti/recepta-detail.%D0%BC%D0%BE%D1%80%D0%BA%D0%BE%D0%B2%D0%B5%D0%BD-%D1%82%D0%B0%D1%80%D1%82.r_id=Recipe_24568713.html",
    image:
      "https://firebasestorage.googleapis.com/v0/b/foodchainapp-1531482755524.appspot.com/o/kaufland%2Frecipes%2Frecipe20890641_voll-auf-die-moehre-tarte.webp?alt=media&token=01c04416-c589-46f6-a395-7f612ad713e7",
    time: "До 60 минути",
    level: "Начинаещи"
  }
];

const APPLE_RECIPES = [
  {
    title: "Печени ябълки с рикота и хрупкава коричка",
    description: "Продукти (4 порции)",
    url: "https://www.kaufland.bg/recepti/tursene-recepti/recepta-detail.%D0%BF%D0%B5%D1%87%D0%B5%D0%BD%D0%B8-%D1%8F%D0%B1%D1%8A%D0%BB%D0%BA%D0%B8-%D1%80%D0%B8%D0%BA%D0%BE%D1%82%D0%B0-%D1%85%D1%80%D1%83%D0%BF%D0%BA%D0%B0%D0%B2%D0%B0-%D0%BA%D0%BE%D1%80%D0%B8%D1%87%D0%BA%D0%B0.r_id=BG_1819.html",
    image:
      "https://firebasestorage.googleapis.com/v0/b/foodchainapp-1531482755524.appspot.com/o/kaufland%2Frecipes%2Frecipe7724_ricotta-brataepfel-nussknusperkruste.webp?alt=media&token=4dde8dd0-c0f6-4a16-a777-f4bd8c1c8ea1",
    time: "Над 60 минути",
    level: "Начинаещи"
  },
  {
    title: "Сладкиш с ябълки",
    description: "Продукти (4 порции)",
    url: "https://www.kaufland.bg/recepti/tursene-recepti/recepta-detail.%D1%81%D0%BB%D0%B0%D0%B4%D0%BA%D0%B8%D1%88-%D1%8F%D0%B1%D1%8A%D0%BB%D0%BA%D0%B8.r_id=Recipe_4272302.html",
    image:
      "https://firebasestorage.googleapis.com/v0/b/foodchainapp-1531482755524.appspot.com/o/kaufland%2Frecipes%2FRecipe-bg-4272302_Sladkish-s-qbulki.webp?alt=media&token=c7b12d5f-cbb7-4365-9e0f-49cb912c9c8f",
    time: "Над 60 минути",
    level: "Начинаещи"
  }
];

const RECIPES_BY_PRODUCT = {
  "64f1b4d6875ddb85fd36c1d7": SPINACH_RECIPES,
  "6654b8a5c294260cc4268339": CARROT_RECIPES,
  "6654ba33a4b98a6e25742321": APPLE_RECIPES,
  "6654bd3aa4b98a4d52742323": APPLE_RECIPES
};

const FARM_STORY_FALLBACK =
  "Чудни родни вкуснотии, както ги обичаме по нашите земи. Където кравите пасат най-сладко и киселото мляко е най-кисело. Където вием най-правите хора и най-витите баници. Където морето е най-черно, а сиренето — е не е ли най-бяло! Тук избираме най-дебелата сянка и най-тънките мезета, а седнем ли на масата – няма ставане. Брей! Това е българско!";

const extractItemId = () => {
  const basePath = "/items_details/";
  const { pathname } = window.location;
  const index = pathname.indexOf(basePath);
  if (index >= 0) {
    return pathname.slice(index + basePath.length);
  }
  return pathname.substring(15);
};

const formatDate = value => {
  if (!value) {
    return null;
  }

  let date = new Date(value);

  if (Number.isNaN(date.getTime())) {
    const numericValue = Number(value);
    if (!Number.isNaN(numericValue)) {
      date = new Date(numericValue > 1e12 ? numericValue : numericValue * 1000);
    }
  }

  if (Number.isNaN(date.getTime())) {
    return null;
  }

  return date.toLocaleDateString("bg-BG", {
    day: "2-digit",
    month: "short",
    year: "numeric"
  });
};

const getHarvestLabel = (productId, inventory) => {
  if (productId && HARVEST_DATE_OVERRIDES.products[productId]) {
    return HARVEST_DATE_OVERRIDES.products[productId];
  }

  if (inventory?._id && HARVEST_DATE_OVERRIDES.inventories[inventory._id]) {
    return HARVEST_DATE_OVERRIDES.inventories[inventory._id];
  }

  const formatted = formatDate(inventory?.harvest_date);
  return formatted ? `Дата на бране: ${formatted}` : null;
};

const MapPageItemsDetails = () => {
  const [state, setState] = useState({
    loading: true,
    productInfo: null,
    placeInfo: null,
    inventoryDetails: null,
    error: null
  });
  const [showFullStory, setShowFullStory] = useState(false);

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const itemId = extractItemId();

    fetch(`https://api.dontwaste.me/inventories/${itemId}`, {
      signal: controller.signal
    })
      .then(response => {
        if (!response.ok) {
          throw new Error("Failed to load inventory details");
        }
        return response.json();
      })
      .then(data => {
        if (!isMounted) {
          return;
        }

        const product = data.itemProduct?.[0] || null;
        const place = data.itemPlace?.[0] || null;
        const item = data.item || null;

        track("Kaufland QR Scan", {
          property: "visited",
          item_id: itemId,
          product_id: product?._id || item?.product_id || null,
          product_name: item?.product_name || product?.name || null,
          producer: place?.name || item?.place_name || null,
          place_id: place?._id || item?.place_id || null,
          article: item?.part_number != null ? String(item.part_number) : null,
          producer_hidden: item?.hide_producer === true || place?.hide_producer === true
        });

        setState({
          loading: false,
          productInfo: product,
          placeInfo: place,
          inventoryDetails: item,
          error: null
        });
      })
      .catch(error => {
        if (controller.signal.aborted) {
          return;
        }
        console.error(error);
        track("Kaufland QR Scan", { property: "visited", item_id: itemId, load_failed: true });
        if (isMounted) {
          setState(prev => ({ ...prev, loading: false, error: "FETCH_ERROR" }));
        }
      });

    return () => {
      isMounted = false;
      controller.abort();
    };
  }, []);

  const { loading, productInfo, placeInfo, inventoryDetails, error } = state;

  // Per-product switch: `hide_producer: true` on the fc-items document (or on the
  // fc-places document) hides everything that identifies the producer on this page:
  // the producer label, the location line and map, the place story, video and image.
  // Remove the field to show the producer again - no redeploy needed.
  const hideProducer =
    inventoryDetails?.hide_producer === true || placeInfo?.hide_producer === true;

  const recipes = useMemo(
    () => (productInfo?._id ? RECIPES_BY_PRODUCT[productInfo._id] || [] : []),
    [productInfo]
  );

  // Optional per-product content stored on the fc-products document (edit data, no redeploy):
  //   about:        { paragraphs: [string], highlights: [string], facts: [{ label, value }] }
  //   recipe_texts: [{ title, intro, ingredients: [{ label, text }], steps: [{ label, text }] }]
  const about = productInfo?.about && typeof productInfo.about === "object" ? productInfo.about : null;
  const aboutParagraphs = Array.isArray(about?.paragraphs)
    ? about.paragraphs.filter(p => typeof p === "string" && p.trim())
    : [];
  const aboutHighlights = Array.isArray(about?.highlights)
    ? about.highlights.filter(h => typeof h === "string" && h.trim())
    : [];
  const aboutFacts = Array.isArray(about?.facts) ? about.facts.filter(f => f && f.label && f.value) : [];
  const hasAbout = aboutParagraphs.length > 0 || aboutHighlights.length > 0 || aboutFacts.length > 0;
  const textRecipes = Array.isArray(productInfo?.recipe_texts)
    ? productInfo.recipe_texts.filter(r => r && r.title)
    : [];

  const videoId = hideProducer ? null : placeInfo?.contact?.name;
  const hasVideo = typeof videoId === "string" && videoId.length === 11;

  const handleShare = () => {
    if (!inventoryDetails) {
      return;
    }

    shareOnMobile(
      {
        text: `Хей, открих невероятен продукт в Кауфланд: ${inventoryDetails.product_name}.`,
        url: `https://app.traceground.com/items_details/${inventoryDetails._id}`,
        title: "Traceground -> Kaufland",
        images: productInfo?.image
      },
      message => window.alert(message)
    );
  };

  if (loading) {
    return (
      <div className="map-details__loader">
        <Loader active inline="centered">
          Зареждаме информация...
        </Loader>
      </div>
    );
  }

  if (error || !productInfo || !placeInfo || !inventoryDetails) {
    return (
      <Segment placeholder className="map-details__section">
        <Header icon>
          <Icon name="food" />
          Не успяхме да заредим данните за продукта. Моля, опитайте отново по-късно.
        </Header>
      </Segment>
    );
  }

  const harvestLabel = getHarvestLabel(productInfo?._id, inventoryDetails);
  const producerName = hideProducer ? null : placeInfo?.name;
  // Optional `producer_label` on the fc-items document replaces the producer name in
  // the label (e.g. "Български производител за Кауфланд" while the real producer is hidden).
  const producerLabel =
    typeof inventoryDetails?.producer_label === "string" && inventoryDetails.producer_label.trim()
      ? inventoryDetails.producer_label.trim()
      : null;
  const producerText = producerLabel
    ? `Производител – ${producerLabel}`
    : producerName
      ? `Производител – "${producerName}"`
      : null;
  const metadata = [
    {
      icon: "barcode",
      label: "Партида",
      value: inventoryDetails?.part_number
    },
    {
      icon: "calendar check outline",
      label: "Бране",
      value: formatDate(inventoryDetails?.harvest_date)
    },
    {
      icon: "shipping fast",
      label: "Пакетиране",
      value: formatDate(inventoryDetails?.pack_date)
    }
  ].filter(item => item.value);

  const storyText = !hideProducer && placeInfo?.created_by && placeInfo.created_by.length > 50
    ? placeInfo.created_by
    : FARM_STORY_FALLBACK;
  const MAX_STORY_CHARS = 420;
  const isLongStory = storyText.length > MAX_STORY_CHARS;
  const truncatedStory = isLongStory
    ? `${storyText.slice(0, MAX_STORY_CHARS).trimEnd()}…`
    : storyText;
  const activeStoryText = showFullStory ? storyText : truncatedStory;
  const storyParagraphs = activeStoryText
    .split(/\n+/)
    .filter(Boolean)
    .map(paragraph => paragraph.trim());

  const coordinates = placeInfo?.location?.coordinates;
  const hasMap = !hideProducer && Array.isArray(coordinates) && coordinates.length >= 2;
  const dynamicBrandImage = !hideProducer && placeInfo?.place_image_url
    ? [{ url: placeInfo.place_image_url, alt: placeInfo?.name || "Ферма" }]
    : [];
  const brandImages = [...BRAND_STORY_IMAGES, ...dynamicBrandImage];

  return (
    <div className="map-details-page">
      <Segment className="map-details__section map-details__hero">
        <Grid stackable>
          <Grid.Column width={6}>
            <Image
              src={productInfo?.image || FALLBACK_PRODUCT_IMAGE}
              alt={inventoryDetails.product_name || producerName || "Продукт"}
              className="map-details__product-image"
            />
          </Grid.Column>
          <Grid.Column width={10}>
            <Header as="h1" className="map-details__title" style={{ textAlign: 'center' }}>
              {inventoryDetails.product_name}
              {!hideProducer && placeInfo?.description && (
                <Header.Subheader>
                  <Icon name="location arrow" />
                  {placeInfo.description}
                </Header.Subheader>
              )}
            </Header>

            <div className="map-details__meta">
              {producerText && (
                <Label className="map-details__meta-item">
                  <Icon name="factory" />
                  {producerText}
                </Label>
              )}
              {/* {harvestLabel && (
                <Label className="map-details__meta-item">
                  <Icon name="truck" />
                  {harvestLabel}
                </Label>
              )} */}
            </div>

            {/* {metadata.length > 0 && (
              <div className="map-details__metadata-grid">
                {metadata.map(item => (
                  <div key={item.label} className="map-details__metadata-item">
                    <Icon name={item.icon} />
                    <span className="map-details__metadata-label">{item.label}</span>
                    <span className="map-details__metadata-value">{item.value}</span>
                  </div>
                ))}
              </div>
            )} */}

            <div className="map-details__hero-footer">
              <Button
                icon
                labelPosition="left"
                className="map-details__share-button"
                onClick={handleShare}
              >
                <Icon name="share alternate" />
                Сподели продукта
              </Button>
              <br />
              <Image src={KAUFLAND_LOGO} alt="Kaufland" className="map-details__brand-mark" />
            </div>
          </Grid.Column>
        </Grid>
      </Segment>

      {hasAbout && (
        <Segment className="map-details__section">
          <Header as="h3" className="map-details__section-title">
            <Icon name="info circle" />
            <Header.Content>За продукта</Header.Content>
          </Header>
          <div className="map-details__about">
            {aboutParagraphs.map((paragraph, index) => (
              <p key={`p${index}`}>{paragraph}</p>
            ))}
            {aboutHighlights.length > 0 && (
              <ul className="map-details__about-highlights">
                {aboutHighlights.map((highlight, index) => (
                  <li key={`h${index}`}>
                    <Icon name="check" />
                    <span>{highlight}</span>
                  </li>
                ))}
              </ul>
            )}
            {aboutFacts.length > 0 && (
              <dl className="map-details__about-facts">
                {aboutFacts.map((fact, index) => (
                  <div key={`f${index}`} className="map-details__about-fact">
                    <dt>{fact.label}</dt>
                    <dd>{fact.value}</dd>
                  </div>
                ))}
              </dl>
            )}
          </div>
        </Segment>
      )}

      {productInfo?.ingredients && (
        <Segment className="map-details__section">
          <Header as="h3" className="map-details__section-title">
            <Icon name="food" />
            <Header.Content>Хранителни вещества на 100 г.</Header.Content>
          </Header>
          <div className="map-details__nutrition-grid">
            {NUTRITION_FACTS.map(fact => {
              const value = productInfo.ingredients[fact.key];
              if (!value) {
                return null;
              }
              return (
                <div key={fact.key} className="map-details__nutrition-card">
                  <div className="map-details__nutrition-icon-wrapper">
                    {NUTRITION_ICONS[fact.iconKey] &&
                      NUTRITION_ICONS[fact.iconKey](fact.color)}
                  </div>
                  <div className="map-details__nutrition-copy">
                    <span className="map-details__nutrition-label">{fact.label}</span>
                    <span className="map-details__nutrition-value">{value}</span>
                  </div>
                </div>
              );
            })}
          </div>
          <p className="map-details__nutrition-source">
            Източник на данните за макронутриентите: Национален регистър, Национален център по обществено здраве и анализи.
          </p>
        </Segment>
      )}

      <Segment className="map-details__section">
        <Header as="h3" className="map-details__section-title">
          <Icon name="leaf" />
          <Header.Content>Сертификати и устойчивост</Header.Content>
        </Header>
        <div className="map-details__certification-grid">
          {CERTIFICATION_LOGOS.map(logo => (
            <div key={logo.url} className="map-details__cert-card">
              <div className="map-details__cert-logo">
                <Image src={logo.url} alt={logo.alt} />
              </div>
              <div className="map-details__cert-copy">
                <span className="map-details__cert-title">{logo.title}</span>
                <span className="map-details__cert-description">{logo.description}</span>
              </div>
            </div>
          ))}
        </div>
      </Segment>

      <Segment className="map-details__section">
        <Header as="h3" className="map-details__section-title">
          <Icon name="picture" />
          <Header.Content>Визия и атмосфера</Header.Content>
        </Header>
        <div className="map-details__brand-images">
          {brandImages.map(image => (
            <Image key={image.url} src={image.url} alt={image.alt} className="map-details__brand-image" rounded />
          ))}
        </div>
      </Segment>

      {hasMap && (
        <Segment className="map-details__section">
          <Header as="h3" className="map-details__section-title">
            <Icon name="map marker alternate" />
            <Header.Content>Локация на фермата</Header.Content>
          </Header>
          <div className="map-details__map-wrapper">
            <ProductMap
              latitude={coordinates[0]}
              longitude={coordinates[1]}
              label={producerName || "Ферма"}
            />
          </div>
        </Segment>
      )}

      <Segment className="map-details__section">
        <Header as="h3" className="map-details__section-title">
          <Icon name="users" />
          <Header.Content>Информация за фермата</Header.Content>
        </Header>
        <Container text className="map-details__farm-story">
          {storyParagraphs.map((paragraph, index) => (
            <p key={index}>{paragraph}</p>
          ))}
          {isLongStory && (
            <Button
              basic
              size="small"
              className="map-details__story-toggle"
              onClick={() => setShowFullStory(prev => !prev)}
            >
              {showFullStory ? "Скрий" : "Прочети повече"}
            </Button>
          )}
        </Container>
      </Segment>

      {hasVideo && (
        <Segment className="map-details__section">
          <Header as="h3" className="map-details__section-title">
            <Icon name="video" />
            <Header.Content>Видео от фермата</Header.Content>
          </Header>
          <div className="map-details__video">
            <YouTube videoId={videoId} className="map-details__youtube" />
          </div>
        </Segment>
      )}

      {(recipes.length > 0 || textRecipes.length > 0) && (
        <Segment className="map-details__section">
          <Header as="h3" className="map-details__section-title">
            <Icon name="utensils" />
            <Header.Content>Рецепти</Header.Content>
          </Header>
          {recipes.length > 0 && (
          <Card.Group itemsPerRow={2} stackable doubling className="map-details__recipes">
            {recipes.map(recipe => (
              <Card
                key={recipe.url}
                href={recipe.url}
                target="_blank"
                rel="noopener noreferrer"
                className="map-details__recipe-card"
              >
                <Image src={recipe.image} alt={recipe.title} wrapped ui={false} />
                <Card.Content>
                  <Card.Header>{recipe.title}</Card.Header>
                  {recipe.description && <Card.Description>{recipe.description}</Card.Description>}
                </Card.Content>
                <Card.Content extra>
                  <div className="map-details__recipe-meta">
                    <span>
                      <Icon name="clock outline" />
                      {recipe.time}
                    </span>
                    <span>
                      <Icon name="food" />
                      {recipe.level}
                    </span>
                  </div>
                </Card.Content>
              </Card>
            ))}
          </Card.Group>
          )}
          {textRecipes.length > 0 && (
            <div className="map-details__text-recipes">
              {textRecipes.map((recipe, index) => (
                <details
                  key={`r${index}`}
                  className="map-details__text-recipe"
                  onToggle={event => {
                    if (event.currentTarget.open) {
                      track("Recipe Opened", {
                        recipe: recipe.title,
                        item_id: inventoryDetails?._id || null,
                        product_name: inventoryDetails?.product_name || null
                      });
                    }
                  }}
                >
                  <summary className="map-details__text-recipe-title">{recipe.title}</summary>
                  <div className="map-details__text-recipe-body">
                    {recipe.intro && <p className="map-details__text-recipe-intro">{recipe.intro}</p>}
                    {Array.isArray(recipe.ingredients) && recipe.ingredients.length > 0 && (
                      <>
                        <h4>Необходими продукти</h4>
                        <ul>
                          {recipe.ingredients.map((part, partIndex) => (
                            <li key={partIndex}>
                              {part.label && <strong>{part.label}: </strong>}
                              {part.text}
                            </li>
                          ))}
                        </ul>
                      </>
                    )}
                    {Array.isArray(recipe.steps) && recipe.steps.length > 0 && (
                      <>
                        <h4>Приготвяне</h4>
                        <ol>
                          {recipe.steps.map((part, partIndex) => (
                            <li key={partIndex}>
                              {part.label && <strong>{part.label}: </strong>}
                              {part.text}
                            </li>
                          ))}
                        </ol>
                      </>
                    )}
                  </div>
                </details>
              ))}
            </div>
          )}
        </Segment>
      )}

      {PROMO_SECTIONS.map(section => (
        <Segment key={section.title} className="map-details__section">
          <Header as="h3" className="map-details__section-title">
            <Icon name={section.icon} />
            <Header.Content>{section.title}</Header.Content>
          </Header>
          <div className="map-details__promo-images">
            {section.images.map(image => (
              <Image key={image.url} src={image.url} alt={image.alt} rounded />
            ))}
          </div>
        </Segment>
      ))}

      <Header as="h4" className="map-details__footer-link">
        Виж повече на:{" "}
        <a href="https://www.kaufland.bg/" target="_blank" rel="noopener noreferrer">
          kaufland.bg
        </a>
      </Header>
    </div>
  );
};

export default MapPageItemsDetails;
